export const SOCKET_CONNECTED_EVENT = 'socket:connected';
export const CONSOLIDATED_REPORT_UPDATED_EVENT = 'consolidated-report:updated';
